const invitePartnerWithBonification = async (
	token: string,
	companyId: string,
	emailToInvite: string
) => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/users/invite-partner-with-bonification/${companyId}`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify({
				emailToInvite: emailToInvite
			})
		}
	);

	return response.json();
};

export default invitePartnerWithBonification;
